module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: _vm.show && 'is-active'
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title is-1 text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "content text-center"
  }, [_vm._v("\n        Please be certain to enter the user's information correctly\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "title input",
    attrs: {
      "placeholder": "user's name"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEmail),
      expression: "userEmail"
    }],
    staticClass: "title input",
    attrs: {
      "placeholder": "user's email"
    },
    domProps: {
      "value": (_vm.userEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control content text-center"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserRole),
      expression: "newUserRole"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUserRole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "teacher"
    }
  }, [_vm._v("teacher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "coach"
    }
  }, [_vm._v("coach")])])])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendEmail),
      expression: "sendEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendEmail) ? _vm._i(_vm.sendEmail, null) > -1 : (_vm.sendEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendEmail = $$c
        }
      }
    }
  }), _vm._v("\n          Send Email\n        ")])]), _vm._v(" "), _c('section', {
    staticClass: "button-container text-center"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("\n          Add\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-630c0dba"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddUser.vue
// module id = 1049
// module chunks = 0